"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./../styles/Elecinstallation.css"; // Import the new combined CSS file

// Assuming Header, Footer, Silk are in the same directory or adjust path
import Header from './Header';
import Footer from './Footer';
import Beams from "./Beams"; 

// Asset imports (assuming they are in ../assets/ relative to this component)
import image1 from "../assets/elecinstall17A.jpeg";
import image2 from "../assets/elecinstall11A.jpeg";
import image3 from "../assets/elecinstall12A.jpeg";
import image4 from "../assets/elecinstall13A.jpeg";
import image5 from "../assets/elecinstall14A.jpeg";
import image6 from "../assets/elecinstall153A.jpeg";

import image7 from "../assets/elecinstall153A.jpeg";
import image8 from "../assets/installation6A.jpeg";


// --- Content of former EnggDesignHero.js, renamed and classnames updated ---
const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        <h2 className="elec-design-hero-title">Electrical Installation</h2>
        <p className="elec-design-hero-description">
          Reliable support for new installations and upgrades
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <img
                src={item.image}
                alt={item.title}
                className="elec-design-hero-step-image"
                data-aos="fade-left"
              />
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {typeof item.paragraph === "string" ? (
                  <p>{item.paragraph}</p>
                ) : (
                  <>
                    <p>{item.paragraph?.text}</p>
                    {Array.isArray(item.paragraph?.points) &&
                      item.paragraph.points.map((point, idx) => (
                        <p key={idx} className="elec-design-hero-step-point">
                          <span className="elec-design-hero-arrow-icon">→</span> {point}
                        </p>
                      ))}
                  </>
                )}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

// --- Content of former Engineeringdesign.js, renamed and classnames updated ---
const Elecinstallation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
    {
      title: "SUBSTATION INSTALLATION",
      image: image7,
      paragraph: {
        points: [
          "We provide a complete installation services from HV Transformers, HV & LV Switchgear, HV & LV panels, HV & LV cables, Switch rooms, and Distribution circuits for a fully fledged substations having capacities from 11 kV to 400 kV.",
        ]
        }
    },
    {
      title: "INSTALLATION OF GIS SUBSTATIONS",
      image: image8,
      paragraph: {
       points: [
  "Our Installation and startup team comprises wide range of skill-sets to setup all power systems and related assets in place as per the design specification of a substation. Our services provide sound technicalities and engineering expertise with greater extent of guidance to achieve a safe installation and startup. We provide coverage for all your installation needs."
]
      }
    },
  ];

  return (
    <>
      <Header />
      <div className="elec-installation-page-container"> {/* Updated class */}
        <div className="elec-installation-page-header"> {/* Updated class */}
          <h1>Electrical Installation</h1>
          <p>
           Our Electrical Installation Services provide comprehensive solutions tailored to meet the unique needs of residential, commercial, and industrial projects. From initial design and planning to final commissioning, we ensure safe, efficient, and code-compliant installation of electrical systems. Our skilled technicians handle everything from wiring, switchgear installation, lighting systems, and power distribution to advanced automation and control setups. Prioritizing quality and safety, we use the latest tools and industry best practices to deliver reliable electrical infrastructure that supports your operational goals and future expansion.
            <br />
          </p>
        </div>

        <div className="elec-installation-cube-wrapper"> {/* Updated class */}
          <div className="elec-installation-cube-gallery"> {/* Updated class */}
            <img src={image1} alt="Engineering Slide 1" />
            <img src={image2} alt="Engineering Slide 2" />
            <img src={image3} alt="Engineering Slide 3" />
            <img src={image4} alt="Engineering Slide 4" />
            <img src={image5} alt="Engineering Slide 5" />
            <img src={image6} alt="Engineering Slide 6" />
          </div>
        </div>

        <div className="elec-installation-silk-bg"> {/* Updated class */}
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>
      </div>

      <ElecDesignHeroSection data={timelineData} /> {/* Use the internal component */}
      <Footer />
    </>
  );
};

export default Elecinstallation;